module.exports = __webpack_public_path__ + "img/d.142206ef.jpg";